<div *ngIf="formGroup" class="input__container" [formGroup]="formGroup">
  <label class="label__input__lovers" [ngClass]="{ disabled: disabled, temImagemEsquerda: iconeEsquerdo != '' }"
    [class.label__input__lovers-floating]="
      formGroup.get(controlName)?.value || isInputFocused
    " [for]="id">{{ label }}</label>
    
    <i
    *ngIf="loading"
    class="fa fa-spinner fa-spin icone__input__lovers"
  ></i>

  <input class="input__lovers" [ngClass]="{
    'error-border':
    corPrincipal &&
      (
        formGroup.get(controlName).invalid &&
        formGroup.get(controlName).errors &&
        formGroup.get(controlName).touched ||
        habilitaIconeErro ||
        formGroup.get(controlName).errors && formGroup.get(controlName).touched
      ),

    'error-border-branco':
      !corPrincipal &&
      (
        formGroup.get(controlName).invalid &&
        formGroup.get(controlName).errors &&
        formGroup.get(controlName).touched ||
        habilitaIconeErro ||
        formGroup.get(controlName).errors && formGroup.get(controlName).touched
      ),
    'validado': !corPrincipal && habilitaIconeCheck &&  formGroup.get(controlName).valid,
    'validado-branco': corPrincipal && habilitaIconeCheck &&  formGroup.get(controlName).valid,
    'disabled': disabled,
    'temImagemEsquerda': iconeEsquerdo != ''
  }"
  [id]="id" [type]="type ? type : 'text'" [placeholder]="getPlaceholder()" [disabled]="disabled"
  [formControlName]="controlName" [mask]="mask" [pattern]="pattern" [maxlength]="maxlength" [tabindex]="tab"
  (focus)="onInputFocus()" (blur)="onInputBlur()" (input)="onInputChange($event)" (ngModelChange)="onInputChange($event)" (click)="reset()"/>
  

  <img class="icone__direito__alerta" *ngIf="habilitaIconeAlerta && !loading" src="assets/images/inputs/alerta.svg"
    alt="Ícone direito do campo" />

  <img class="icone__direito__alerta" *ngIf="habilitaIconeCheck && !loading && formGroup.get(controlName).valid" src="assets/images/inputs/ok.svg"
    alt="Ícone direito do campo" />

  <img [ngClass]="{ 'icone__direita__error': exibirSenha}" class="icone__direito__alerta" *ngIf="formGroup.get(controlName).errors && formGroup.get(controlName).touched && !loading" src="assets/images/inputs/erro.svg"
    alt="Ícone direito do campo" />

  <img class="icone__direito__alerta olho__senha" *ngIf="exibirSenha && !loading" [src]="
      mostrarSenha
        ? 'assets/images/inputs/olho_aberto.svg'
        : 'assets/images/inputs/olho_fechado.svg'
    " alt="Ícone direito do campo" (click)="toggleSenha()" />

  <img *ngIf="iconeEsquerdo != '' && !loading" class="icone__esquerdo" [src]="iconeEsquerdo" alt="Ícone esquerdo" />

  <img *ngIf="iconeDireitoSrc != '' && !loading" class="icone__direito" [src]="iconeDireitoSrc" alt="Ícone direito" />
</div>


<!-- <div *ngIf="campoInvalidoEVazio()" [ngClass]="{mensagem__erro : corPrincipal, mensagem__erro__branco : !corPrincipal}"
[innerHTML]="getMessageError()"
> -->

<div *ngIf="campoInvalidoEVazio()" class="mensagem__erro"
[innerHTML]="getMessageError()"
>
</div>

<div *ngIf="habilitaIconeCheck" class="mensagem__validado">
  {{ labelCampoValidado }}
</div>

<!-- <div *ngIf="mensagemGenerica" class="mensagem__generica">
  {{ mensagemGenerica }}
</div> -->